import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IBusinessType } from "../BusinessTypeModel";

export const getAllBusinessTypes = createAsyncThunk(
  "Master/BusinessFindAll",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/BusinessFindAll`,
        {
          BusinessType: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Business Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createBusinessType = createAsyncThunk(
  "Master/ManageBusinessTypeInsert",
  async (BusinessType: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageBusinessTypeInsert`,
        BusinessType
      );
      if (response.data.Status === 201) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create BusinessType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateBusinessType = createAsyncThunk(
  "Master/ManageBusinessTypeUpdate",
  async (BusinessType: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageBusinessTypeUpdate`,
        BusinessType
      );
      if (response.data?.Status === 201) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update BusinessType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getBusinessTypeById = createAsyncThunk(
  "Master/BusinessTypeFindByID",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/BusinessTypeFindByID`,
        {
          BusinessDetailsGUID: ID,
        }
      );
      const result = response.data?.Data as any;

      return {
        ID: result?.ID,
        BusinessDetailsGUID: result?.BusinessDetailsGUID,
        BusinessType: result?.BusinessType,
        ISActive: result?.IsActive === true ? 1 : 2,
      } as IBusinessType;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching BusinessType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteBusinessType = createAsyncThunk(
  "Master/ManageBusinessTypeDelete",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageBusinessTypeDelete`,
        {
          BusinessDetailsGUID: ID,
        }
      );
      if (response.data?.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting BusinessType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const findAllActiveBusinessType = createAsyncThunk(
  "Master/BusinessFindAllActive",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Master/BusinessFindAllActive`
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching BusinessType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const BusinessTypeActiveInactive = createAsyncThunk(
  "Master/ManageBusinessTypeActiveInActive",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageBusinessTypeActiveInActive`,
        formData
        // OperationType: ACTIVEINACTIVE_TYPE,
      );
      if (response.data?.Status === 201) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive BusinessType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
